import { styled } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const LoaderCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  alignItems: 'flex-start',
  gap: 20,
}));

//ProjectLoader

export const TextSkeleton = styled(Skeleton)(({ theme }) => ({
  width: 95,
  height: 20,
}));

export const RoleSkeleton = styled(Skeleton)(({ theme }) => ({
  height: 126,
}));
